import script from "./NewsPagePopupTelegramBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPagePopupTelegramBlock.vue?vue&type=script&setup=true&lang=js"

import "./NewsPagePopupTelegramBlock.vue?vue&type=style&index=0&id=03e419f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e419f6"]])

export default __exports__